<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="flex flex-col h-full bg-white dark:bg-slate-900 w-full max-w-sm mx-auto rounded-xl overflow-hidden">
      <div class="px-6 py-4 border-b border-n-weak flex justify-between items-center bg-n-surface-1">
        <h2 class="text-base font-semibold m-0 text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="i-lucide-pencil w-5 h-5 text-n-brand"></span>
          Editar Agendamento
        </h2>
        <woot-button variant="clear" icon="dismiss" color-scheme="secondary" @click="onClose" />
      </div>

      <div class="flex-1 px-6 py-6 space-y-4">
        <div>
          <label class="text-xs font-medium text-slate-700 dark:text-slate-300 block mb-1">Mensagem</label>
          <textarea
            v-model="editContent"
            class="w-full text-sm border border-n-weak rounded-lg p-2 bg-transparent text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-1 focus:ring-n-brand resize-none"
            rows="4"
            placeholder="Digite sua mensagem aqui..."
          ></textarea>
        </div>

        <div>
          <label class="text-xs font-medium text-slate-700 dark:text-slate-300 block mb-1">Data e Hora</label>
          <div class="w-full relative">
            <DateTimePicker
              :value="editScheduledDate"
              placeholder="Escolher Data e Hora"
              confirm-text="Confirmar Horário"
              class="w-full"
              @change="handleDateChange"
            />
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-2 px-6 py-4 border-t border-n-weak bg-n-surface-2">
        <woot-button variant="clear" @click="onClose" :is-loading="isSaving">
          Cancelar
        </woot-button>
        <woot-button :disabled="!isFormValid" color-scheme="primary" @click="confirm" :is-loading="isSaving">
          Salvar Alterações
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import DateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';

export default {
  components: {
    DateTimePicker,
  },
  props: {
    show: { type: Boolean, default: false },
    message: { type: Object, default: () => ({}) },
    isSaving: { type: Boolean, default: false },
  },
  data() {
    return {
      editContent: '',
      editScheduledDate: null,
    };
  },
  computed: {
    isFormValid() {
      return this.editContent.trim() !== '' && this.editScheduledDate;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.editContent = this.message.content || '';
        this.editScheduledDate = this.message.scheduled_at ? new Date(this.message.scheduled_at) : null;
      }
    },
  },
  methods: {
    handleDateChange(date) {
      this.editScheduledDate = date;
    },
    onClose() {
      this.$emit('close');
    },
    confirm() {
      if (!this.isFormValid) return;
      this.$emit('save', {
        id: this.message.id,
        content: this.editContent,
        scheduled_at: this.editScheduledDate,
      });
    },
  },
};
</script>
